module.exports = __webpack_public_path__ + "static/media/10_CALCINHA_DRAPEADA_LARGA_LISA_02.db601d95.jpg";